import type { AttributesCount, Meta } from '../../../generated/frontend'
import type { AppliedFilterItem } from '../../../shared/types/ReviewsFilters'
import { removeUrlQueryStringAndFragment } from '../../../shared/utils/remove-url-query-string-and-fragment'

export const getDataLayerScriptContent = ({
  meta,
  attributesCount,
  fullUrl,
  appliedFilters,
  hasVariants,
}: {
  meta: Partial<Meta>
  attributesCount?: AttributesCount
  fullUrl?: string
  appliedFilters?: AppliedFilterItem[]
  hasVariants?: boolean
}) => {
  const {
    bestBuyCount,
    dontBuyCount,
    firstLookCount,
    notTestedProductsCount,
    testedProductsCount,
    productsCount,
  } = attributesCount || {}
  const selectedFilters = appliedFilters?.map(({ label }) => label).join(' | ')

  return {
    content_type: 'product-listing',
    vertical: meta?.taxonomyHierarchy?.vertical?.slug,
    sub_vertical: meta?.taxonomyHierarchy?.subVertical?.slug,
    category: meta?.taxonomyHierarchy?.category?.slug,
    super_category: meta?.taxonomyHierarchy?.superCategory?.slug,
    category_id:
      meta?.taxonomyHierarchy?.category?.additional_items?.custom_taxonomy_configuration?.meta_data
        ?.akeneo_code,
    productsCount: productsCount,
    testedProductsCount: testedProductsCount,
    notTestedProductsCount: notTestedProductsCount,
    bestBuyCount: bestBuyCount,
    dontBuyCount: dontBuyCount,
    firstLookCount: firstLookCount,
    selectedFilters,
    wcdPageUrl: removeUrlQueryStringAndFragment(fullUrl),
    pageComponents: hasVariants ? 'color variants' : null,
  }
}
